import React from 'react';
function Quote({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 9c0-2.222.563-5 4.5-5C11.438 4 12 7.333 12 9M12 14c0 2.222-.563 5-4.5 5C3.562 19 3 15.667 3 14M3 9v6M12 9v6M9 16l4 4M17 11v6M22 17c0 .889-.313 2-2.5 2-2.188 0-2.5-1.333-2.5-2M17 13h2"
      />
    </svg>
  );
}

export default Quote;
